export default "__VITE_ASSET__DZjsdJl2__"